

/**
* directives.slider Module
*
* Description
*/
var app = angular.module('directives.sliderServices', [])

    require('./services/service.js');
    require('./stylesheet/style.scss');
    require('./directives/directive.js');
    require('./services/oneclickpayment.factory.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServices/index.js
 ** module id = 226
 ** module chunks = 1
 **/